import { create } from 'zustand';

export type JobStatus = 'processing' | 'completed' | 'failed';

export interface AIWorkflowJobResult<T> {
  jobId: string;
  status: JobStatus;
  result: null | T;
  error: null | string;
  location: string;
  runId: string | null;
}

export interface AIWorkflowState<T> {
  workflowJobId?: string;
  jobStarted: (jobId: string) => void;
  workflowResult?: AIWorkflowJobResult<T>;
  setResults: (results: AIWorkflowJobResult<T>) => void;
  reset: () => void;
  hasTimedOut: boolean;
  hasErrored: boolean;
  setHasTimedOut: () => void;
  setHasErrored: () => void;
  isJobInProgress: boolean;
}

export function createAiWorkflowStore<T>() {
  return create<AIWorkflowState<T>>((set) => ({
    workflowJobId: undefined,
    jobStarted: (jobId: string) =>
      set(() => ({
        workflowJobId: jobId,
        isJobInProgress: true,
      })),
    workflowResult: undefined,
    setResults: (result: AIWorkflowJobResult<T>) => {
      set(() => ({ workflowResult: result, isJobInProgress: false }));
    },
    reset: () =>
      set({
        workflowJobId: undefined,
        workflowResult: undefined,
        hasTimedOut: false,
        hasErrored: false,
        isJobInProgress: false,
      }),
    hasTimedOut: false,
    hasErrored: false,
    setHasTimedOut: () => {
      set(() => ({
        hasTimedOut: true,
        isJobInProgress: false,
      }));
    },
    setHasErrored: () => {
      set(() => ({
        hasErrored: true,
        isJobInProgress: false,
      }));
    },
    isJobInProgress: false,
  }));
}
